export { default as BriefcaseSolidIcon } from './BriefcaseSolidIcon';
